import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import { Reveal } from "@/components/Reveal";

const steps = [
  {
    number: "01",
    title: "Diagnosis",
    description: "Understand where you are in the Noisy Market. We audit your current position, analyze the competitive landscape, and identify your opportunity for differentiation.",
  },
  {
    number: "02",
    title: "Strategy",
    description: "Map your Signal Zone. We craft your strategic position, the distinct territory where your brand becomes the clear, obvious choice for your audience.",
  },
  {
    number: "03",
    title: "Tactics",
    description: "Build and amplify your signal. We create the visual and verbal identity, then activate your brand with marketing that reinforces your position across every touchpoint.",
  },
];

const ApproachSection = () => {
  return (
    <section className="section-padding bg-black border-t border-white/10">
      <div className="container-wide">
        {/* Section Header */}
        <div className="max-w-3xl mx-auto mb-16 text-center">
          <Reveal className="mx-auto mb-4">
            <p className="label bg-purple text-white px-3 py-1 inline-block">HOW WE WORK</p>
          </Reveal>
          <Reveal className="mx-auto mb-6 pb-4 !overflow-visible" delay={0.1}>
            <h2 className="text-2xl sm:text-3xl md:display-md text-white flex items-center justify-center gap-2 md:gap-4 flex-wrap">
              Problem <ArrowRight className="text-purple w-6 h-6 md:w-12 md:h-12" /> Solution <ArrowRight className="text-purple w-6 h-6 md:w-12 md:h-12" /> Execution
            </h2>
          </Reveal>
          <Reveal className="mx-auto" delay={0.2}>
            <p className="body-lg text-white/60 font-light">
              Strategy drives our framework. Each phase sharpens focus until your brand stands unmistakably clear.
            </p>
          </Reveal>
        </div>

        {/* Process Steps - Roadmap */}
        <div className="flex flex-col lg:flex-row items-center justify-center gap-8 lg:gap-4">
          {steps.map((step, index) => (
            <div key={step.number} className="flex items-center w-full lg:w-auto">
              {/* Step Card */}
              <Reveal delay={index * 0.1} className="flex-1 lg:w-[320px]">
                <div className="group h-full p-8 bg-[#000000] border border-white/10 rounded-lg transition-all duration-500 hover:bg-[#c0ff09] hover:border-[#c0ff09]">
                  {/* Number */}
                  <div className="mb-6">
                    <span className="text-4xl font-bold text-purple group-hover:text-black transition-colors duration-500">
                      {step.number}
                    </span>
                  </div>

                  {/* Content */}
                  <h3 className="text-2xl font-bold mb-4 text-white group-hover:text-black transition-colors duration-300">
                    {step.title}
                  </h3>
                  <p className="text-white/60 leading-relaxed text-sm group-hover:text-black transition-colors duration-300">
                    {step.description}
                  </p>
                </div>
              </Reveal>

              {/* Arrow between steps */}
              {index < steps.length - 1 && (
                <div className="hidden lg:block mx-4 text-purple">
                  <ArrowRight size={32} strokeWidth={2} />
                </div>
              )}
            </div>
          ))}
        </div>

        {/* Link to How Page */}
        <Reveal delay={0.4} className="mt-12 mx-auto w-fit">
          <Link
            to="/how#framework"
            className="inline-flex items-center gap-2 font-light text-white hover:text-[#c0ff09] hover:gap-4 transition-all duration-300 border-b border-white pb-1"
          >
            Explore Our Methodology
            <ArrowRight size={16} />
          </Link>
        </Reveal>
      </div>
    </section>
  );
};

export default ApproachSection;
